import AccountPage from './AccountPage.vue'
import Addresses from './Addresses.vue'
import AddressForm from './AddressForm.vue'
import UsersList from './UsersList.vue'
import BudgetList from './BudgetList.vue'
import BudgetForm from './BudgetForm.vue'
import MpkList from './MpkList.vue'
import MpkForm from './MpkForm.vue'
import SettingPage from './SettingPage.vue'
import Invoices from './InvoicePage.vue'
import UserForm from './UserForm.vue'
import SaleStat from './SaleStat.vue'

export default {
  routers() {
    return [
      {
        path: '/account',
        name: 'account',
        component: AccountPage,
      },
      {
        path:'/account/user',
        name: 'user',
        component: UserForm,
      },
      {
        path: '/account/invoices',
        name: 'invoices',
        component: Invoices
      },
      {
        path: '/account/addresses',
        name: 'addresses',
        component: Addresses
      },
      // {
      //   path: '/account/addresses/add',
      //   name: 'addAddress',
      //   component: AddressForm
      // },
      {
        path: '/account/users',
        name: 'users',
        component: UsersList
      },
      {
        path: '/account/budgets',
        name: 'budgets',
        component: BudgetList
      },
      {
        path: '/account/budgets/add',
        name: 'addBudget',
        component: BudgetForm
      },
      {
        path: '/account/mpks',
        name: 'mpks',
        component: MpkList
      },
      {
        path: '/account/mpks/add',
        name: 'addMpk',
        component: MpkForm
      },
      {
        path: '/account/settings',
        name: 'settings',
        component: SettingPage
      },
      {
        path: '/account/stats',
        name: 'stats',
        component: SaleStat
      },

    ];
  }
}





// WEBPACK FOOTER //
// ./src/components/account/src/account/Router.js